import { useEffect, useState } from "react";
import { _Countries } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import usePaginator from "../../../../../../../modules/theme/Component/usePaginator";
import Select from "react-select";

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectCountry = ({ onChange, label, idSelector, returnType }: Props) => {

    const { lista, setLista, instance } = useDataBean(_Countries);
    const paginador = usePaginator();
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDCountries === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDCountries,
                    label: `${found.DataBeanProperties.Iso3} - ${found.DataBeanProperties.NameCountry}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.gerCountryRender(null, null, {}).then(
            (resp: any) => {
                setLista(resp.List)
                paginador.setPages(resp.NumberOfPages);
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDCountries,
        label: `${item.DataBeanProperties.Iso3} - ${item.DataBeanProperties.NameCountry}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "País"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Pais..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    )
}